import { Component } from '@angular/core';
import { NgSelectSearch } from '@flyfreely-portal-ui/ng-select';
import { FieldType } from '@ngx-formly/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormlyGraphQlPaginationService } from './helpers';

/**
 * A version of the Formly ng-select that can load items dynamically and paginate using a scoped graph-ql service that is passed in.
 * The scoped service should be passed in using the 'service' value in the Formly template options.
 * For an example implementation, see 'src\flyfreely\adminui2\jurisdictions\edit\jurisdiction-edit-dialogue.component.ts'
 */
@Component({
    selector: 'formly-graphql-ng-select',
    template: `
        <div class="form-group">
            <ng-select
                [items]="items"
                [clearable]="!to.required"
                [formControl]="formControl"
                [bindLabel]="to.labelProp || 'label'"
                [bindValue]="to.valueProp || 'value'"
                appendTo="body"
                [loading]="loading"
                [virtualScroll]="true"
                [searchFn]="searchFn"
                (scrollToEnd)="onSelectScroll()"
                (search)="onSelectSearch($event)"
                (close)="onSelectClose()"
                (open)="onSelectOpen()"
            >
            </ng-select>
        </div>
    `
})
export class FormlyGraphQlNgSelect extends FieldType {
    graphQlService: FormlyGraphQlPaginationService;
    items: any = [];
    loading = false;
    isOpen = false;
    searchFn: (term: string, item: any) => boolean;

    private ngUnsubscribe$ = new Subject<void>();

    ngOnInit() {
        this.graphQlService = this.to.service;
        this.graphQlService.loading$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(loading => (this.loading = loading && this.isOpen));
        this.graphQlService.results$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(results => (this.items = results));
        this.graphQlService.refreshItems(this.formControl.value);
        this.searchFn = this.graphQlService.searchFn;
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    onSelectScroll() {
        this.graphQlService.onSelectScroll();
    }

    onSelectSearch(search: NgSelectSearch) {
        this.graphQlService.onSelectSearch(search);
    }

    onSelectOpen() {
        this.isOpen = true;
        if (this.graphQlService.onSelectOpen) {
            this.graphQlService.onSelectOpen();
        }
    }

    onSelectClose() {
        this.isOpen = false;
        this.graphQlService.onSelectClose();
    }
}
